import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { ProdutosProvider } from './context/produtos_context'
import { FilterProvider } from './context/filter_context'
import { CartProvider } from './context/cart_context'
import { UserProvider } from './context/user_context'
import { Auth0Provider } from '@auth0/auth0-react'
// dev-pu8wyk-g.us.auth0.com
// 7vHgXJ01aWGyMVLWdZUwQSUapigdjfKu
ReactDOM.render(
  <Auth0Provider
    domain='pedropbazzo.us.auth0.com'
    clientId='aKy18bfVJUiLn4rUmlUikljRF0T3PIVE'
    redirectUri={window.location.origin}
    cacheLocation='localstorage'
  >
    <UserProvider>
      <ProdutosProvider>
        <FilterProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </FilterProvider>
      </ProdutosProvider>
    </UserProvider>
  </Auth0Provider>,

  document.getElementById('root')
)
